
/*
  TODO:
    - add buymeacoffe monthly button

  plan:
  - navbar
    logo: image from discord ili onaj moj logo
    - almost done
    - add selected page to be colored
    - add click on discord image -> /home

  - main page
    i: https://www.jeremymoreau.io/
    i: https://www.loicbrijawi.com/
    i: https://winstonzhao.ca/
    i: https://jinblack.it/
    i: https://pepsipu.com/
    i: https://juliapoo.github.io/
    
    voleo bih da pozadina bude black i isto kao onom batici
    kad skrolujes da pise o meni kao sto pise pepsipu
  
  - exploit_dev
    voleo bih da ima kao tree ctf-ova i zadataka
    ctf -----> cakectf -> 2023 -> bofwow
                  |         |___> memorial_cabbage
                  |
                  |_____> 2022 -> crc32pwn
                            |___> welkenme

    cve -----> 2020 - 19234
      |______> 2023 - 23994

    wargame -> pwnable.kr
      |______> pwnable.tw
      |______> pawnyable -> LK01
                  |_______> LK02...

    samo markdown posts zadataka + downloadable zadaci
  
  - cryptography
    i: https://eprint.iacr.org/complete/

    ideja, mozda da ima sectino most read i tu su ta 4 pdf-a
    a pored toga lici na eprint sajt, samo linkovi i mala slicica pored
    pdf listing website

  - projects
    i: https://imp.ress.me/maker
    i: https://dribbble.com/shots/8809716-Projects-Page-for-Azonic-Films

    ovo moze i u home page ili kao galerija u odvojeni page
    za projects samo slike kao mozaic toga sto sam nap

  - acomplishments
    i: https://imp.ress.me/infosec
    i: https://adragos.ro/achievements/
    isto kao adragos, da lici na cv?
*/

import { Suspense } from 'react';
import { BrowserRouter as Router, useLocation } from './utils/router';

import routes from './routes';
import NavBar from './components/NavBar';

import './App.css';

function AppShell() {
  const location = useLocation();
  const pathname = location.pathname.length > 1
    ? location.pathname.replace(/\/+$/, '')
    : location.pathname;
  const adminHost = process.env.REACT_APP_ADMIN_HOST;
  const isAdminHost = adminHost && window.location.hostname === adminHost;
  const isAdminRoute = isAdminHost || pathname.startsWith('/admin');
  const adminRoute = routes.find((route) => route.path === '/admin');
  const activeRoute = routes.find((route) => {
    if (route.path === pathname) return true;
    if (!route.path.includes('/:slug')) return false;
    const prefix = route.path.slice(0, route.path.indexOf('/:slug'));
    const remainder = pathname.slice(prefix.length + 1);
    return pathname.startsWith(`${prefix}/`)
      && remainder.length > 0
      && !remainder.includes('/');
  });

  return (
    <>
      {!isAdminRoute && <NavBar />}
      <Suspense fallback={<div className="min-h-screen bg-black text-gray-400 grid place-items-center">Loading…</div>}>
        {isAdminHost
          ? adminRoute.component
          : activeRoute?.component || (
            <div className="min-h-screen bg-black text-white grid place-items-center">
              <h1 className="text-3xl">404 – Page not found</h1>
            </div>
          )}
      </Suspense>
    </>
  );
}

// main app
function App() {
  return (
    <div className="App">
    <Router>
      <AppShell />
    </Router>
    </div>
  );
}

export default App;
